import { Typography } from "@material-tailwind/react";
import HorizontalSeparator from '../components/Utils/HorizontalSeparator.js';

function ContactForm() {
  return (
	<div className="relative mx-auto w-full md:w-3/6">
		<div className="MentionLegalElement">
			<Typography variant="h4">Propriétaire</Typography>
			<div variant="paragraph">
				<p>Nom : Claudia Pellegrin</p>
				<p>Adresse : France</p>
				<p>Email : tournee.accord@gmail.com</p>
			</div>
			<HorizontalSeparator/>
		</div>
		<div className="MentionLegalElement">
			<Typography variant="h4">Hébergeur</Typography>
			<div variant="paragraph">
				<p>Le site est hébergé sur un serveur personnel.</p>
				<p>Matériel : Raspberry Pi 5</p>
				<p>Adresse de l&apos;hébergement : France</p>
			</div>
			<HorizontalSeparator/>
		</div>
		<div className="MentionLegalElement">
			<Typography variant="h4">Responsabilité</Typography>
			<Typography variant="paragraph">
				Le propriétaire du site met tout en œuvre pour assurer l&apos;exactitude des informations diffusées et leur mise à jour. Toutefois, il ne peut garantir l&apos;exactitude, la complétude et l&apos;actualité des informations publiées. L&apos;utilisateur est seul responsable de l&apos;utilisation qu&apos;il fait des informations fournies sur ce site.
			</Typography>
			<HorizontalSeparator/>
		</div>
		<div className="MentionLegalElement">
			<Typography variant="h4">Propriété intellectuelle</Typography>
			<Typography variant="paragraph">
				Tous les contenus présents sur ce site (textes, images, etc.) sont protégés par les lois en vigueur sur la propriété intellectuelle. Toute reproduction, même partielle, sans l&apos;autorisation préalable de Claudia Pellegrin est interdite.
			</Typography>
			<HorizontalSeparator/>
		</div>
		<div className="MentionLegalElement">
			<Typography variant="h4">Données personnelles</Typography>
			<Typography variant="paragraph">
				Le site ne collecte aucune donnée personnelle sans votre consentement. Pour toute question concernant la gestion de vos données, vous pouvez contacter Claudia Pellegrin à tournee.accord@gmail.com.
			</Typography>
			<HorizontalSeparator/>
		</div>
		<div className="MentionLegalElement">
			<Typography variant="h4">Cookies</Typography>
			<Typography variant="paragraph">
				Ce site n&apos;utilise pas de cookies ou autres traceurs pour collecter des informations sur votre navigation.
			</Typography>
			<HorizontalSeparator/>
		</div>
		<div className="MentionLegalElement">
			<Typography variant="h4">Litiges</Typography>
			<Typography variant="paragraph">
				En cas de litige, les lois françaises s&apos;appliquent et les tribunaux compétents seront ceux de France.
			</Typography>
		</div>
	</div>
  );
}

export default ContactForm;
